import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { localizedDayjs } from 'tradera-utils/date';

export const useDayJs = () => {
    const preferredLanguageCodeIso2 = useSelector(
        state => state.language.preferred.languageCodeIso2
    );
    const localizedDayjsCallback = useCallback(
        (...args) => localizedDayjs(preferredLanguageCodeIso2)(...args),
        [preferredLanguageCodeIso2]
    );
    return localizedDayjsCallback;
};

export const withDayJs = WrappedComponent => {
    const WithDayJs = props => {
        const localizedDayjs = useDayJs();
        return <WrappedComponent dayjs={localizedDayjs} {...props} />;
    };

    WithDayJs.displayName = `withDayJs(${WrappedComponent.displayName ||
        WrappedComponent.name}`;

    return WithDayJs;
};
